<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<div
    class="flex w-full flex-auto justify-center [background-color:var(--mat-tree-container-background-color)] dark:bg-card sm:p-4 md:p-8"
>
    <!-- Navigation -->
    @if (isScreenSmall) {
        <fuse-vertical-navigation
            class="dark bg-gray-900 print:hidden"
            [mode]="'over'"
            [name]="'mainNavigation'"
            [navigation]="navigation.default"
            [opened]="false"
        >
        </fuse-vertical-navigation>
    }

    <!-- Wrapper -->
    <div
        class="flex min-w-0 max-w-360 flex-auto flex-col items-center overflow-hidden shadow-2xl dark:shadow-none sm:rounded-xl border-2 border-gray-300 dark:border-gray-600"
    >
        <!-- Header -->
        <div
            class="[background-color:var(--mat-tree-container-background-color)] relative z-49 flex h-16 w-full flex-0 items-center border-b px-4 dark:bg-default sm:h-20 md:px-6 print:hidden"
        >
            @if (!isScreenSmall) {
                <!-- Horizontal navigation -->
                <fuse-horizontal-navigation
                    class="mr-2 flex-1"
                    [name]="'mainNavigation'"
                    [navigation]="navigation.horizontal"
                ></fuse-horizontal-navigation>
            }
            <!-- Navigation toggle button -->
            @if (isScreenSmall) {
                <button
                    class="mr-2 text-default hover:text-primary dark:text-default dark:hover:text-primary"
                    mat-icon-button
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
            }
            <!-- Components -->
            <div class="flex items-center space-x-1 pl-2 sm:space-x-2">
                <languages class="text-default hover:text-primary dark:text-default dark:hover:text-primary"></languages>
                <fuse-fullscreen class="hidden md:block text-default hover:text-primary dark:text-default dark:hover:text-primary"></fuse-fullscreen>
                <!-- Theme selector -->
                <themes class="text-default hover:text-primary dark:text-default dark:hover:text-primary"></themes>
                <!-- Dark mode toggle -->
                <button
                    class="text-default hover:text-primary dark:text-default dark:hover:text-primary"
                    mat-icon-button
                    (click)="toggleScheme()"
                >
                    <mat-icon [svgIcon]="scheme === 'dark' ? 'heroicons_outline:sun' : 'heroicons_outline:moon'"></mat-icon>
                </button>
                <workspaces class="text-default hover:text-primary dark:text-default dark:hover:text-primary"></workspaces>
                <user class="text-default hover:text-primary dark:text-default dark:hover:text-primary"></user>
            </div>
        </div>

        <!-- Content -->
        <div class="bg-default flex w-full flex-auto flex-col">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            @if (true) {
                <router-outlet></router-outlet>
            }
        </div>
    </div>
</div>
